"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SpeechOptions = (function () {
    function SpeechOptions() {
    }
    return SpeechOptions;
}());
exports.SpeechOptions = SpeechOptions;
//# sourceMappingURL=SpeechOptions.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@conversationlearner/webchat/built/SpeechOptions.js
// module id = 1465
// module chunks = 0